
import React from 'react';
import { 
    summarizeOfferCheckboxes, allCustomersConfirmed, idConfirmed, checkIfVIDexists, 
    offerErrors, allPayersConfirmed, allHealthQuestionsConfirmed, allBeneficiaryValid, 
    contactInfoConfirmed, Spinner, getContractOverviewPDF, idStepValid, usaAandKomfortDynamik } from '../../utils'
import connectWithStore from '../../utils/store'
import { store } from '../../store'
import { withRouter } from "react-router";
import { createContract, setStale } from '../../api/offers/actions'
import { nextStep, prevStep, setStep, openModal, closeModal } from '../../api/gui/actions'
import { Link } from 'react-router-dom'
import LinkButton from '../link-button'

import { STEP_START, STEP_COLLECT_INFO, STEP_SHOW_QUOTE, STEP_HEALTH_QUESTIONS, STEP_PAYMENT, STEP_ID, STEP_SIGNATURE, STEP_NO_SIGNATURE, STEP_FINAL, getStepOrder, CONTRACT_STATUS_WAITING } from '../../constants'
import { SvgDownloadIcon } from '../svg';

class TilbodNavigation extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            disabled: false
        }
        this.shouldShowForwardButton = this.shouldShowForwardButton.bind(this)
        this.allOffersReceived = this.allOffersReceived.bind(this)
        this.submitData = this.submitData.bind(this)
    }

    shouldShowBackwardButton() {
        switch (this.props.gui.currentStep) {
            case STEP_START:
                return false
            default:
                return true
        }
    }

    allOffersReceived() {
        let checks = []
        if (Object.keys(this.props.offers.offers).length > 0 && offerErrors(this.props)) {
            checks.push(false)
        } else {checks.push(true)}
        return checks.every((v) => v === true)
    }

    shouldShowForwardButton() {
        switch (this.props.gui.currentStep) {
            case STEP_START:
                if (summarizeOfferCheckboxes(this.props.offers.offerQueryParameters, true).length > 0) {
                    return true
                }
                return false
            case STEP_COLLECT_INFO:
                if (allCustomersConfirmed(this.props)) {
                    return true
                }
                return false
            case STEP_SHOW_QUOTE:                
                let vidStop = checkIfVIDexists("VID", this.props) || checkIfVIDexists("VIDT", this.props)

                let checks = []

                if (vidStop) {
                    checks.push(false)
                }  else {checks.push(true)}
                if (Object.keys(this.props.offers.offers).length > 0 && offerErrors(this.props)) {
                    checks.push(false)
                } else {checks.push(true)}
                if (this.props.brokers && this.props.brokers.data === true) {
                    checks.push(true)
                } else { checks.push(false)}
                
                return checks.every((v) => v === true)

                // if (Object.keys(this.props.offers.offers).length > 0) {
                //     console.log("offers received")
                //     return true
                // } else {
                //     return false
                // }
                // if (this.props.offers.offers && Object.keys(this.props.offers.offers).length > 0) {
                //     let errors = offerErrors(this.props)

                //     if (errors === false && (vidStop === false || vidStop === undefined) && (this.props.brokers && this.props.brokers.data === true)) {
                //         return true
                //     } 
                // } else {
                //     return false
                // }
                // return shouldRenderBtn;

            case STEP_HEALTH_QUESTIONS:
                if (this.props.gui.showStopper) {
                    return false
                } else if (allHealthQuestionsConfirmed(this.props)) {
                    return true
                }
                return false
            case STEP_PAYMENT:
                if (allPayersConfirmed(this.props) && allBeneficiaryValid(this.props)) {
                    return true
                }
                return false
            case STEP_ID:
                if (idConfirmed(this.props) && contactInfoConfirmed(this.props) && !usaAandKomfortDynamik(this.props)) {
                    return true
                }
                return false
            case STEP_SIGNATURE:
                return true
            case STEP_NO_SIGNATURE:
                return false
            case STEP_FINAL:
                return false
            default:
                return false
        }
    }

    forwardButtonText() {
        switch (this.props.gui.currentStep) {
            default:
                return "Áfram"
        }
    }

    backwardButtonText() {
        switch (this.props.gui.currentStep) {
            default:
                return "Til baka"
        }
    }

    submitData(stepLength, paperSigning) {
        if (this.state.disabled) {
            return;
        }
        this.setState({disabled: true});
        let data = Object.assign({}, this.props.offers)
        data = Object.assign(data, this.props.customers)
        data.infoCollection = this.props.infoCollection
        data.healthQuestions = this.props.healthQuestions
        data.nationalRegistry = this.props.nationalRegistry
        data.fundTable = this.props.fundTable
        data.identification = this.props.identification
        data.physical_signing = false
        data.euro_value = this.props.gui.currency
        let payers = Object.assign({}, this.props.payers)
        data.payers = payers
        let employers = Object.assign({}, this.props.employers)
        data.employers = employers
        let insuranceTakers = Object.assign({}, this.props.insuranceTakers)
        data.insuranceTakers = insuranceTakers

        data.paperSigning = paperSigning

        Promise.resolve(this.props.dispatch(createContract(JSON.stringify(data))))
        .then(d => {
            if (d.status !== "error") {
                this.props.dispatch(nextStep(this.props.offers.offerQueryParameters))
                this.props.history.push(`/step/${stepLength-1}`) // Go to final step
            }
        })
    }

    getOverviewPDF() {
        $('#samantekt-download-button').show();

        let data = Object.assign({}, this.props.offers)
        data = Object.assign(data, this.props.customers)
        data.infoCollection = this.props.infoCollection
        data.physical_signing = false
        data.euro_value = this.props.gui.currency
        let insuranceTakers = Object.assign({}, this.props.insuranceTakers)
        data.insuranceTakers = insuranceTakers
        let nationalRegistry = Object.assign({}, this.props.nationalRegistry)
        data.nationalRegistry = nationalRegistry

        getContractOverviewPDF(data, '#samantekt-download-button')

    }

    render() {
        let CORRECT_STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters);
        const { contractSigning, isFetching, error_list, status } = this.props.offers;

        return (
            <div className="container xs-pt-10 xs-pb-50">
                <div className="row">
                    { this.props.gui.currentStep == CORRECT_STEP_ORDER[CORRECT_STEP_ORDER.length-2] ?
                        <>
                            <div className="col-12 text-center button-container">
                                <button onClick={() => this.submitData(CORRECT_STEP_ORDER.length, false)} className="next-btn btn btn-primary xs-m-10" disabled={this.state.disabled}>Útbúa samningsgögn (rafræn undirritun) {isFetching && <Spinner />}</button>
                                <button onClick={() => this.submitData(CORRECT_STEP_ORDER.length, true)} className="next-btn btn btn-primary xs-m-10" disabled={this.state.disabled}>Útbúa samningsgögn (undirritað á pappír) {isFetching && <Spinner />}</button>
                            </div>
                            <div className="col-12 text-center button-container">
                                <LinkButton onClick={() => this.props.dispatch(prevStep(this.props.offers.offerQueryParameters))} className="back-btn btn btn-primary xs-m-10" to={location => `/step/${CORRECT_STEP_ORDER.indexOf(this.props.gui.currentStep)-1}`} disabled={!this.shouldShowBackwardButton()} >{this.backwardButtonText()}</LinkButton>
                                <button className="btn btn-warning" onClick={() => this.getOverviewPDF()} >
                                    <SvgDownloadIcon />
                                    <span className="xs-ml-10">Sækja samantekt</span>
                                    <i style={{display: 'none'}} id={`samantekt-download-button`} className="fa fa-spin fa-sync-alt xs-ml-10" />
                                </button>
                            </div>
                        </>
                        :
                        <div className="col-12 text-center button-container">
                            <LinkButton onClick={() => this.props.dispatch(prevStep(this.props.offers.offerQueryParameters))} className="back-btn btn btn-primary xs-m-10" to={location => `/step/${CORRECT_STEP_ORDER.indexOf(this.props.gui.currentStep)-1}`} disabled={!this.shouldShowBackwardButton()} >{this.backwardButtonText()}</LinkButton>
                            { this.props.gui.currentStep === STEP_SHOW_QUOTE && this.allOffersReceived() && 
                                <button className="btn btn-warning" onClick={() => this.getOverviewPDF()} >
                                    <SvgDownloadIcon />
                                    <span className="xs-ml-10">Sækja samantekt</span>
                                    <i style={{display: 'none'}} id={`samantekt-download-button`} className="fa fa-spin fa-sync-alt xs-ml-10" />
                                </button>}
                            <LinkButton onClick={() => this.props.dispatch(nextStep(this.props.offers.offerQueryParameters))} className="next-btn btn btn-primary xs-m-10" to={location => `/step/${CORRECT_STEP_ORDER.indexOf(this.props.gui.currentStep)+1}`} disabled={!this.shouldShowForwardButton()}>{this.forwardButtonText()}</LinkButton>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

TilbodNavigation.defaultProps = { }

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        brokers: {},
        insuranceTakers: {},
        payers: {},
        employers: {},
        healthQuestions: {},
        fundTable: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.identification = (state.identification === undefined) ? {} : state.identification
    f.brokers = (state.brokers === undefined) ? {} : state.brokers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.employers = (state.employers === undefined) ? {} : state.employers
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions

    return f;
}

export default connectWithStore(store, withRouter(TilbodNavigation), mapStateToProps);
